import { render, staticRenderFns } from "./maintenance-setting-form.vue?vue&type=template&id=33651086"
import script from "./maintenance-setting-form.vue?vue&type=script&lang=js"
export * from "./maintenance-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports